<ng-template #content>
  <div class="modal-header">
    <h5 class="modal-title">Action confirm</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="onCancel()"></button>
  </div>
  <div class="modal-body">
    <p [innerHTML]="ctx?.message"></p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="onCancel()">No</button>
    <button type="button" class="btn btn-primary" (click)="onConfirm()">Yes</button>
  </div>
</ng-template>
